import React, { useEffect } from 'react';
import { FormGroup, Label, Input, } from 'reactstrap';
import { sumBy, keyBy, sortBy, groupBy, pickBy, get, sum } from 'lodash';
import { toast } from 'react-toastify';
import numeral from 'numeral';
import { format as formatDate, } from 'date-fns';

import { prefectures, boxSizesForCount, amazonProductSizeTypes, } from '../../shared/config';
import { fieldDisplayValue, } from '../../shared/util';
import { generalSettingsFields } from '../../shared/models/tenant';
import { setSizes, documentNumberHavings, } from '../../shared/models/receivingRequest';
import { getAddressByPostalCode, } from '../../util';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import ModelFormModal from '../modals/ModelFormModal';
import Page from '../hocs/Page';
import ModalButton from '../ModalButton';
import UseCountDetail from '../UseCountDetail';

const { entries, keys } = Object;

export default Page(function UseCounts (props) {
  const { tenant } = props;
  const products = useCollectionSubscription(tenant.ref.collection('products').orderBy('createdAt'));
  const productsById = keyBy(products, 'id');
  const useCounts = useCollectionSubscription(tenant.ref.collection('useCounts').orderBy('date', 'desc'));

  return (
    <div className="use-counts container-fluid">
      <div className="p-4 bg-white my-4">
        <div className="mt-3">
          <table className="table table-bordered">
            <thead className="thead-light text-center">
              <tr>
                <th rowSpan={2}>年月</th>
                <th colSpan={10}>オプション</th>
                <th rowSpan={2}>加工件数</th>
                <th rowSpan={2}>完了出荷依頼数</th>
                <th rowSpan={2}>出荷件数</th>
                <th rowSpan={2}>toB出荷件数</th>
                <th rowSpan={2}>不明件数</th>
                <th rowSpan={2}>不明件数(箱)</th>
                <th rowSpan={2}>保管日数</th>
                <th rowSpan={2}>入荷件数</th>
                <th rowSpan={2}>入庫点数</th>
                <th rowSpan={2}>追加ピッキング数</th>
                <th rowSpan={2}>Amazon納品数</th>
                <th rowSpan={2}></th>
              </tr>
              <tr>
                <th>追加検品</th>
                <th>加工</th>
                <th>OPP梱包(入)</th>
                <th>納品書・明細書確認保管</th>
                <th>OPP梱包(出)</th>
                <th>プチプチ梱包</th>
                <th>チラシ同封</th>
                <th>添付ファイルの印刷同封</th>
                <th>納品書同封</th>
                <th>着払いで出荷</th>
              </tr>
            </thead>
            <tbody>
              {
                useCounts.map((useCount) => {
                  const { id, ref, date, receivingRequestOptionCounts, shippingRequestOptionCounts, combiningCounts = {}, shippingRequestsCount, shippingRequestBoxCounts, toBeShippingRequestBoxCounts = {}, unknownReceivingRequestCount, storageDays, receivingCount, shelvingCounts, extraPickingsCount, unknownInventoriesCount, amazonShipmentItemsCount, } = useCount;

                  return (
                    <tr key={id}>
                      <td>
                        {formatDate(date.toDate(), 'yyyy/MM')}
                      </td>
                      <td className="text-right">
                        {numeral(sum(Object.values(receivingRequestOptionCounts.check))).format()}
                      </td>
                      <td className="text-right">
                        {
                          keys(setSizes).map((setSize) => {
                            const value = sumBy(Object.values(receivingRequestOptionCounts.set), setSize);
                            return value ? (
                              <div key={setSize} className="text-nowrap">
                                {setSizes[setSize]?.label}: {numeral(value).format()}
                              </div>
                            ) : null;
                          })
                        }
                      </td>
                      <td className="text-right">
                        {numeral(sum(Object.values(receivingRequestOptionCounts.opp || {}))).format()}
                      </td>
                      <td className="text-right">
                        {numeral((receivingRequestOptionCounts.keepDocuments || []).length).format()}
                      </td>
                      <td className="text-right">
                        {
                          keys(boxSizesForCount).map((boxSize) => {
                            const value = sumBy(Object.values(shippingRequestOptionCounts.opp), boxSize);
                            return value ? (
                              <div key={boxSize} className="text-nowrap">
                                {boxSizesForCount[boxSize].label}: {numeral(value).format()}
                              </div>
                            ) : null;
                          })
                        }
                      </td>
                      <td className="text-right">
                        {
                          keys(boxSizesForCount).map((boxSize) => {
                            const value = sumBy(Object.values(shippingRequestOptionCounts.puchi), boxSize);
                            return value ? (
                              <div key={boxSize} className="text-nowrap">
                                {boxSizesForCount[boxSize].label}: {numeral(value).format()}
                              </div>
                            ) : null;
                          })
                        }
                      </td>
                      <td className="text-right">
                        {numeral(Object.values(shippingRequestOptionCounts.flyer).length).format()}
                      </td>
                      <td className="text-right">
                        {numeral(Object.values(shippingRequestOptionCounts.print).length).format()}
                      </td>
                      <td className="text-right">
                        {numeral(Object.values(shippingRequestOptionCounts.slip || {}).length).format()}
                      </td>
                      <td className="text-right">
                        {numeral(sumBy(Object.values(shippingRequestOptionCounts.cashOnDelivery), _ => sum(Object.values(_)))).format()}
                      </td>
                      <td className="text-right">
                        {
                          keys(boxSizesForCount).map((boxSize) => {
                            const value = sum(Object.values(combiningCounts?.[boxSize] || {}));
                            return value ? (
                              <div key={boxSize} className="text-nowrap">
                                {boxSizesForCount[boxSize].label}: {numeral(value).format()}
                              </div>
                            ) : null;
                          })
                        }
                      </td>
                      <td className="text-right">
                        {numeral(shippingRequestsCount).value()}
                      </td>
                      <td className="text-right">
                        {
                          keys(boxSizesForCount).map((boxSize) => {
                            const value = sumBy(Object.values(shippingRequestBoxCounts), boxSize);
                            return value ? (
                              <div key={boxSize} className="text-nowrap">
                                {boxSizesForCount[boxSize].label}: {numeral(value).format()}
                              </div>
                            ) : null;
                          })
                        }
                      </td>
                      <td className="text-right">
                        {
                          keys(boxSizesForCount).map((boxSize) => {
                            const value = sumBy(Object.values(toBeShippingRequestBoxCounts), boxSize);
                            return value ? (
                              <div key={boxSize} className="text-nowrap">
                                {boxSizesForCount[boxSize].label}: {numeral(value).format()}
                              </div>
                            ) : null;
                          })
                        }
                      </td>
                      <td className="text-right">
                        {numeral(Object.values(unknownReceivingRequestCount).length).format()}
                      </td>
                      <td className="text-right">
                        {numeral(sum(Object.values(unknownInventoriesCount || {}))).format()}
                      </td>
                      <td className="text-right">
                        {
                          keys(boxSizesForCount).map((boxSize) => {
                            const value = sum(Object.values(storageDays?.[boxSize] || {}));
                            return value ? (
                              <div key={boxSize} className="text-nowrap">
                                {boxSizesForCount[boxSize].label}: {numeral(value).format()}
                              </div>
                            ) : null;
                          })
                        }
                      </td>
                      <td className="text-right">
                        {
                          keys(documentNumberHavings).map((documentNumberHaving) => {
                            const value = Object.values(receivingCount?.[documentNumberHaving] || {}).length;
                            return value ? (
                              <div key={documentNumberHaving} className="text-nowrap">
                                {documentNumberHavings[documentNumberHaving].label}: {numeral(value).format()}
                              </div>
                            ) : null;
                          })
                        }
                      </td>
                      <td className="text-right">
                        {sumBy(Object.values(shelvingCounts || {}), _ => sum(Object.values(_)))}
                      </td>
                      <td className="text-right">
                        {numeral(sum(Object.values(extraPickingsCount || {}))).format()}
                      </td>
                      <td className="text-right">
                        {
                          keys(amazonProductSizeTypes).map((amazonProductSizeType) => {
                            const value = sumBy(Object.values(amazonShipmentItemsCount || {}), amazonProductSizeType);
                            return value ? (
                              <div key={amazonProductSizeType} className="text-nowrap">
                                {amazonProductSizeTypes[amazonProductSizeType].label}: {numeral(value).format()}
                              </div>
                            ) : null;
                          })
                        }
                      </td>
                      <td className="text-right">
                        <ModalButton
                          modalProps={{ style: { minWidth: 1000 } }}
                          label="明細"
                          title="明細"
                          content={_ => <UseCountDetail useCount={useCount} tenant={tenant} productsById={productsById} showsSku />}
                        />
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

